module.exports = __webpack_public_path__ + "img/1024.50fd0958.svg";